import { Injectable } from '@angular/core';

import { catchError, map } from 'rxjs/operators';
import { GetFilter, GetPagination } from '@shared/interfacres/request-related';
import { Observable } from 'rxjs';
import { BaseApiService } from '@data-access/common/base-api.service';
import { TopTracksResponse, TracksWithPagination } from '@shared/interfacres/track';
import { environment } from '@env/environment';

@Injectable({providedIn: 'root'})
export class LibraryService extends BaseApiService {
  parseUrl = environment.apiParseUrl;

  getFilteredList(
    name: string,
    filter: GetFilter,
    pagination: GetPagination,
    attributes: {categoryId: number | null, genreId?: number | null, subgenreId?: number | null}
  ): Observable<TracksWithPagination> {

    let apiUrl = `${this.apiUrl}/library/tracks?page=${pagination.page}&limit=${pagination.pageSize}&sortBy=${filter.query}&sortDirection=${filter.order}`;
    if (name) {
      apiUrl += `&search=${name}`;
    }
    if (attributes.genreId) {
      apiUrl += `&genreId=${attributes.genreId}`;
    }
    if (attributes.categoryId) {
      apiUrl += `&categoryId=${attributes.categoryId}`;
    }
    if (attributes.subgenreId) {
      apiUrl += `&subgenreId=${attributes.subgenreId}`;
    }
    return this._httpClient.get<TracksWithPagination>(apiUrl).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }


  getGenresList()  {
    const requestUrl = `${this.apiUrl}/admin/settings/genres`;
    return this._httpClient.get(requestUrl).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }
  getSubGenresList()  {
    const requestUrl = `${this.apiUrl}/admin/settings/subgenres`;
    return this._httpClient.get(requestUrl).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }

  getCategoriesList()  {
    const requestUrl = `${this.apiUrl}/admin/settings/categories`;
    return this._httpClient.get(requestUrl).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }

  getTopTracks() {
    const apiUrl = `${this.apiUrl}/library/tracks/top`;
    return this._httpClient.get<TopTracksResponse[]>(apiUrl).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }

  getDownloadData(id: number) {
    const apiUrl = `${this.parseUrl}/library/track/${id}/download`;
    return this._httpClient.get(apiUrl).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }

  markAsListened(trackId: number) {
    const apiUrl = `${this.apiUrl}/library/track/preview`;
    return this._httpClient.post(apiUrl, {trackId});
  }

}
